import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { APPROVED_LABELS, STATUS_COLORS } from '../../config/const.config';

const ApprovedLabel = ({ value }) => {
  const label = APPROVED_LABELS[value] || 'Unknown';
  const color = STATUS_COLORS[value] || 'primary';

  return (
    <Chip
      label={label}
      color={color}
      variant="filled"
      size="small"
      sx={{ fontWeight: 700 }}
    />
  );
};

ApprovedLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ApprovedLabel;
